<template>
  <section id="technisches">
    <description>Sagen Sie uns, wie wir Ihre Website programmieren sollen.</description>
    <Swiper>
      <tile checkbox-id="parallax" heading="Parallax-Effekte" input="checkbox" icon-id="parallax" :contents="parallaxContent" :hints="parallaxHints" />
      <tile checkbox-id="compantibily" heading="Kompatibilität+" input="checkbox" icon-id="compatibility" :contents="browserContent" :hints="browserHints" />
      <tile checkbox-id="aria" heading="Aria-Labels" input="checkbox" icon-id="tag" :contents="ariaContent" :hints="ariaHints" />
      <tile checkbox-id="socialtags" heading="Social-Tags" input="checkbox" icon-id="tag" :contents="socialContent" :hints="socialHints" />
      <tile checkbox-id="spa" heading="SPA" input="checkbox" icon-id="spa" :contents="spaContent" :hints="spaHints" />
    </Swiper>
    <controller next="/services" />
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import Description from '@/components/Description.vue'
import Swiper from '@/components/Swiper.vue'
import Tile from '@/components/Tile.vue'
import Controller from '@/components/Controller.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
export default {
  components: {
    Description,
    Swiper,
    Tile,
    Controller,
    HowTo,
    InclusiveFooter,
    Made
  },
  data: function () {
    return {
      parallaxContent: [
        { sentence: 'Asynchrones Scrollverhalten z. B. von Hintergrundbildern' },
        { sentence: 'So entstehende 3D-Effekte lockern die Website optisch auf' }
      ],
      parallaxHints: [
        { sentence: 'Scrollt der User durch die Website, scrollen einige Teile langsamer oder gegenläufig' },
        { sentence: 'Oft verwendet bei Hintergrundbildern, um dezenten 3D-Effekt hervorzurufen' }
      ],
      browserContent: [
        { sentence: 'Erweiterte Browser-Kompatibilität für veraltete Browser' },
        { sentence: 'Umfasst veraltete Browser wie Internet Explorer 11' }
      ],
      browserHints: [
        { sentence: 'Garantierte Kompatibilität für Browser, die nicht mehr auf dem aktuellen Stand sind, aber u. U. noch benutzt werden:' },
        { sentence: 'Internet Explorer 11 oder neuer' },
        { sentence: 'Firefox Version 60 oder neuer' },
        { sentence: 'Chrome Version 66 oder neuer' },
        { sentence: 'Safari Version 12 oder neuer' }
      ],
      spaContent: [
        { sentence: 'Ausführung der Website als Single-Page-Application' },
        { sentence: 'Single-Page-Applications erfordern kein Neuladen der Website bei Seitenwechsel' }
      ],
      spaHints: [
        { sentence: 'Ausführung als SPA mittels JavaScript-Frameworks wie z.B. vue.js' },
        { sentence: 'Unterstützung des History-Mode, sofern vom Browser angeboten' }
      ],
      ariaContent: [
        { sentence: 'Einfügen relevanter Aria-Labels zur Gewährleistung der Barrierefreiheit' }
      ],
      ariaHints: [
        { sentence: 'Aria-Labels unterstützen Bedienungshilfen wie Screenreader, zum Beispiel für Menschen mit eingeschränkter Sehfähigkeit' }
      ],
      socialContent: [
        { sentence: 'Einfügen von Meta-Tags für soziale Medien' },
        { sentence: 'Gewährleistet, dass geteilte Inhalte nach Ihren Wünschen angezeigt werden' }
      ],
      socialHints: [
        { sentence: 'Einfügen der Tags für Twitter ("Twitter-Cards") und Meta-Tags nach dem Open Graph Protocol (u.a. für Facebook)' },
        { sentence: 'Kann das SEO-Ranking stark positiv beeinflussen' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#technisches {
  padding-top: 80px;
}
@media (min-height: 420px) {
  #technisches {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #technisches {
    padding-bottom: 127px;
  }
}
@media(min-width:767px) {
  #technisches {
    padding-top: 100px;
  }
}
</style>
